import React from 'react';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { DefaultView, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { PageLeadDefault } from '../../../_lib/components/PageLead';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../../components/organisms/BlockInteractions';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AttributeGroupPageLeadEditForm } from '../forms/AttributeGroupPageLeadEditForm';

type AttributeGroupPageLeadInteractions = Views<DefaultView<{ title: string }> & OptionalEditView<any>>;

export function AttributeGroupPageLeadInteractions({ views, activeView }: AttributeGroupPageLeadInteractions) {
  const { t } = useSonTranslation('AttributeGroups');
  const { elementType } = useBlockContext();
  const { refreshCount, uuid } = useRefreshBlock();

  const createButtonsObject = () =>
    views.edit &&
    createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      'AttributeGroups:pagelead',
      DISPLAY_TYPE.COLLAPSIBLE,
      <>
        <PageLeadDefault title={views.default.embedded.title} invisible />
        <AttributeGroupPageLeadEditForm form={views.edit.embedded.form} />
      </>
    );

  return (
    <BlockInteractions
      headline={{
        text: t('pagelead.titleText'),
        hierarchy: 2,
        visible: true,
      }}
      views={views}
      activeView={activeView}
      buttons={createButtonsObject()}
      refreshCount={refreshCount}
      uuid={uuid}
      elementType={elementType}
    >
      <PageLeadDefault title={views.default.embedded.title} />
    </BlockInteractions>
  );
}
